<template lang="pug">
#report-account-transactions
    v-banner.title-banner(min-height="88")
        .text-h4.font-weight-bold {{ $t('Menu.__Report') }} : {{ $t('Reports.__AgedReceivables') }}
        //- template(v-slot:actions)
        //-     v-btn.my-2.ml-4(rounded dark @click="downloadReport" color="primary") 
        //-         | {{$t("ActionOption.__Export")}}

    v-container
        v-card(color="#fdf1eb", elevation="0")
            v-card-text
                v-form(v-model="formValid", ref="reportform")
                    v-row
                        v-col(cols="12", md="3")
                            v-menu(
                                v-model="startDateMenu",
                                offset-y,
                                :close-on-content-click="false",
                                :nudge-right="40",
                                transition="scale-transition",
                                min-width="290px"
                            )
                                template(v-slot:activator="{ on }")
                                    v-text-field(
                                        v-model="startDate",
                                        hide-details,
                                        clearable,
                                        solo,
                                        dense,
                                        outlined,
                                        readonly,
                                        append-icon="event",
                                        v-on="on",
                                        :placeholder="$t('Placeholder.__Date')",
                                        :rules="[rules.required]"
                                    )
                                v-date-picker(
                                    v-model="startDate",
                                    @input="startDateMenu = false",
                                    :locale="$store.getters['account/language']() == 'tw' ? 'zn-tw' : ''"
                                )
                        v-col.text-right
                            v-btn(rounded, dark, @click="generateReport", color="primary", min-width="112") {{ $t('Reports.__GenerateReport') }}
        v-row(v-if="reportData")
            v-col.text-right.mx-4
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportExcel") 
                    | {{ $t('ActionOption.__Export') }} EXCEL
                v-btn.ml-4(rounded, dark, color="#b4b9be", @click="downloadReportPDF") 
                    | {{ $t('ActionOption.__Export') }} PDF
        v-card#report-data.mt-4(v-if="reportData && reportData.length > 0")
            v-card-text
                v-row
                    v-col(cols="12")
                        v-simple-table.report-table(dense)
                            template(v-slot:default)
                                thead
                                    tr(style="background-color: #fdf1eb")
                                        th 
                                        th.text-right {{ $t('Reports.__NotYetOverdue') }}
                                        th.text-right.dark-col {{ $t('Reports.__30orLess') }}
                                        th.text-right.dark-col {{ $t('Reports.__31to60') }}
                                        th.text-right.dark-col {{ $t('Reports.__61to90') }}
                                        th.text-right.dark-col {{ $t('Reports.__91orMore') }}
                                        th.text-right {{ $t('Reports.__TotalUnpaid') }}
                                tbody
                                    tr(v-for="item in reportData")
                                        td 
                                            .customer {{ item.customerName }}
                                        td.text-right
                                            .no-data(v-if="item['NotYetOverdue'].count == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['NotYetOverdue'].amount, currencyCode) }}
                                                .invoices {{ item['NotYetOverdue'].count }} {{ $t('Reports.__InvoiceAmount') }}
                                        td.text-right.dark-col 
                                            .no-data(v-if="item['30OrLess'].count == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['30OrLess'].amount, currencyCode) }}
                                                .invoices {{ item['30OrLess'].count }} {{ $t('Reports.__InvoiceAmount') }}
                                        td.text-right.dark-col 
                                            .no-data(v-if="item['31To60'].count == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['31To60'].amount, currencyCode) }}
                                                .invoices {{ item['31To60'].count }} {{ $t('Reports.__InvoiceAmount') }}
                                        td.text-right.dark-col 
                                            .no-data(v-if="item['61To90'].count == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['61To90'].amount, currencyCode) }}
                                                .invoices {{ item['61To90'].count }} {{ $t('Reports.__InvoiceAmount') }}
                                        td.text-right.dark-col 
                                            .no-data(v-if="item['91OrMore'].count == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['91OrMore'].amount, currencyCode) }}
                                                .invoices {{ item['91OrMore'].count }} {{ $t('Reports.__InvoiceAmount') }}
                                        td.text-right
                                            .no-data(v-if="item['total'] == 0") --
                                            .has-data(v-else)
                                                .amount {{ getAmountWithCurrency(item['total'], currencyCode) }}
                                                .total-overdue {{ getAmountWithCurrency(item['overdue'], currencyCode) }} {{ $t('Reports.__Overdue') }}
        .no-data.mt-4.text-center.grey-darken-1--text(v-else) {{ $t('Table.__NoData') }}
</template>
<script>
import * as TimeHelper from "@/utils/timeHelper"
import * as accountHelper from "@/utils/accountHelper"
import * as textfieldUtils from "@/utils/textfield.js"
import * as CurrencyHelper from "@/utils/currencies"
import * as PDF from "@/utils/pdf"
import XLSX from "xlsx"
import { saveAs } from "file-saver"
import { Workbook, boldRowText } from "@/utils/excelFileHelper"
import * as pdfFileHelper from "@/utils/pdfFileHelper"

export default {
  mixins: [TimeHelper.mixin, accountHelper.mixin, CurrencyHelper.mixin],

  data() {
    return {
      currencyCode: "TWD",
      formValid: false,
      startDate: "",
      startDateMenu: false,
      accountId: "",
      reportData: null,
      rules: textfieldUtils.rules,
      headers: [
        "",
        this.$t("Reports.__NotYetOverdue"),
        this.$t("Reports.__30orLess"),
        this.$t("Reports.__31to60"),
        this.$t("Reports.__61to90"),
        this.$t("Reports.__91orMore"),
        this.$t("Reports.__TotalUnpaid")
      ]
    }
  },
  computed: {
    filename() {
      return this.$t("Reports.__AgedReceivables") + "_" + this.startDate
    }
  },
  methods: {
    generateReport() {
      this.reportData = null
      this.$refs.reportform.validate()
      if (!this.formValid) {
        return
      }
      this.$store.dispatch("global/startLoading")
      this.$store
        .dispatch("reports/getCustomerAgedReceivables", {
          date: this.startDate
        })
        .then(
          function(response) {
            var totalDic = {
              vendorName: this.$t("Reports.__TotalUnpaid"),
              total: 0,
              overdue: 0
            }
            response.data.map(item => {
              var total = 0
              var overdue = 0
              for (var i of item.agedReceivables) {
                total += i.unpaid
                if (i.description != "NotYetOverdue") overdue += i.unpaid
                item[i.description] = {}
                item[i.description].amount = i.unpaid
                item[i.description].count = i.count
                if (totalDic[i.description] == undefined)
                  totalDic[i.description] = {
                    amount: 0,
                    count: 0
                  }
                totalDic[i.description].amount += i.unpaid
                totalDic[i.description].count += i.count
              }
              item["total"] = total
              item["overdue"] = overdue
              totalDic["total"] += total
              totalDic["overdue"] += overdue
            })
            if (response.data.length > 0) {
              this.reportData = response.data
              this.reportData.push(totalDic)
            }

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    downloadReportExcel() {
      /* convert from array of arrays to workbook */
      var filename = this.filename + ".xlsx"
      var sheetName = this.$t("Reports.__AgedReceivables")
      const workbook = new Workbook()
      var worksheet = workbook.addWorksheet(sheetName)
      worksheet.addRow([this.$store.getters["bizes/biz"]().name])
      worksheet = this.translate2ExcelData(worksheet, this.headers, this.reportData)

      workbook.download(filename)
    },
    translate2ExcelData(worksheet, headers, reportData) {
      boldRowText(worksheet.addRow(headers))
      for (var item of reportData) {
        worksheet.addRow([
          item.customerName,
          this.getAmountWithCurrency(item["NotYetOverdue"].amount),
          this.getAmountWithCurrency(item["30OrLess"].amount),
          this.getAmountWithCurrency(item["31To60"].amount),
          this.getAmountWithCurrency(item["61To90"].amount),
          this.getAmountWithCurrency(item["91OrMore"].amount),
          this.getAmountWithCurrency(item["total"])
        ])
      }
      // data.push([this.$t("Reports.__TotalPurchases"), reportData.totalAmount, reportData.totalPaid]);
      return worksheet
    },
    downloadReportPDF() {
      var filename = this.filename + ".pdf"
      var content = []
      content.push(pdfFileHelper.pdfTitle(this.$store.getters["bizes/biz"]().name))
      content.push(pdfFileHelper.pdfHeader(this.$t("Reports.__AgedReceivables")))
      content.push(this.startDate)
      var tableBody = []
      var tableHeaders = []
      for (var header of this.headers) {
        tableHeaders.push(pdfFileHelper.pdfTableHeader(header))
      }
      tableBody.push(tableHeaders)
      for (const item of this.reportData) {
        // if (i != this.reportData.length -1) {}
        tableBody.push([
          item.customerName || "",
          this.getAmountWithCurrency(item["NotYetOverdue"].amount, this.currencyCode),
          this.getAmountWithCurrency(item["30OrLess"].amount, this.currencyCode),
          this.getAmountWithCurrency(item["31To60"].amount, this.currencyCode),
          this.getAmountWithCurrency(item["61To90"].amount, this.currencyCode),
          this.getAmountWithCurrency(item["91OrMore"].amount, this.currencyCode),
          this.getAmountWithCurrency(item["total"], this.currencyCode)
        ])
      }
      content.push(pdfFileHelper.pdfTableSimple(tableBody))
      pdfFileHelper.downloadPDF(filename, content, "landscape")
    }
    // downloadReport() {
    //     if (this.reportData) {
    //         var filename =
    //             this.$t("Reports.__AgedReceivables") + "_" + this.startDate
    //         this.$store.dispatch("global/startLoading")
    //         PDF.download("#report-data", filename, () => {
    //             this.$store.dispatch("global/stopLoading")
    //         })
    //     }
    // },
  },
  mounted() {
    var today = new Date()
    this.startDate = this.getStringByFormat(today)
    this.generateReport()
  },
  created() {
    this.currencyCode = this.$store.getters["bizes/currencyCode"]()
  }
}
</script>
<style lang="scss" scoped>
.report-table {
  .invoices,
  .total-overdue {
    font-size: 13px;
    color: #505356;
  }
  tr:last-child > td:not(:first-child) {
    border-bottom: 2px solid #e67339;
  }
  .dark-col {
    background-color: #f5c7b0;
  }
}
</style>
